import React from 'react';

import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  Platform,
} from 'react-native';

import {getLightIconForType} from '../../utils/trustContent';

const TrustPin = ({type, title, subtitle, onPress, notification}) => {
  const icon = getLightIconForType(type);
  const isWeb = Platform.OS === 'web';
  return (
    <TouchableOpacity onPress={onPress} style={[isWeb && {flex: 1}]}>
      <View style={[styles.container, isWeb && {flex: 1}]}>
        <View style={styles.iconContainer}>
          {icon && <Image source={icon} style={styles.icon} />}
        </View>
        <View style={styles.textContainer}>
          <Text style={styles.title} numberOfLines={2}>
            {title}
          </Text>
          <Text style={styles.subtitle} numberOfLines={1}>
            {subtitle}
          </Text>
        </View>
        <View style={styles.notificationContainer}>{notification}</View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F8F8F8',
    padding: 4,
    borderRadius: 5,
    alignSelf: 'stretch',
  },
  icon: {
    height: 31,
    width: 31,
  },
  iconContainer: {
    backgroundColor: '#00736D',
    borderRadius: 5,
    padding: 10,
  },
  textContainer: {
    flexDirection: 'column',
    marginLeft: 13,
    flexShrink: 1,
    marginRight: 20,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 19,
    color: '#343A40',
    paddingBottom: 3,
  },
  subtitle: {
    fontSize: 13,
    fontWeight: '600',
    lineHeight: 16,
    color: '#798B93',
  },
  notificationContainer: {
    marginLeft: 'auto',
    marginRight: 10,
  },
});

export default TrustPin;
